"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = require("prop-types");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var Brand = function Brand(_ref) {
  var children = _ref.children,
      href = _ref.href,
      tabIndex = _ref.tabIndex;
  return _react.default.createElement("a", {
    className: "co-brand",
    href: href,
    tabIndex: tabIndex
  }, children);
};

Brand.propTypes = {
  /** {---} One of: @@<Image>@@ @@string@@ */
  children: _propTypes.any.isRequired,
  href: _propTypes.string,
  tabIndex: _propTypes.string
};
Brand.defaultProps = {
  href: '#'
};
var _default = Brand;
exports.default = _default;
Brand.__docgenInfo = {
  "description": "",
  "methods": [],
  "displayName": "Brand",
  "props": {
    "href": {
      "defaultValue": {
        "value": "'#'",
        "computed": false
      },
      "type": {
        "name": "string"
      },
      "required": false,
      "description": ""
    },
    "children": {
      "type": {
        "name": "any"
      },
      "required": true,
      "description": "{---} One of: @@<Image>@@ @@string@@"
    },
    "tabIndex": {
      "type": {
        "name": "string"
      },
      "required": false,
      "description": ""
    }
  }
};